import axios from 'axios';
import errorHandlerFactory from './errorHandler';

const csaListErrorHandler = errorHandlerFactory('An error occured when fetching Csas.');
const counterpartiesErrorHandler = errorHandlerFactory('An error occured when fetching Counterparties.');
const eodErrorHandler = errorHandlerFactory('An error occured when fetching the last batch date');

export const counterparties = () => axios.get('SystemInfo/Counterparties')
    .then(r => r.data).catch(counterpartiesErrorHandler);

export const csaList = () => axios.get('SystemInfo/csas')
    .then(r => r.data).catch(csaListErrorHandler);

export const csaMonitorList = () => axios.get('CsaMonitor/csas')
    .then(r => r.data).catch(csaListErrorHandler);

export const imCsaList = () => axios.get('csa/csaListForSummary')
    .then(r => r.data).catch(csaListErrorHandler);

export const eodDate = () => axios.get('SystemInfo/LastBatchDate')
    .then(r => r.data).catch(eodErrorHandler);

export const csaListByEod = date => axios.get(`Csa/CsasByEod/${date}`)
    .then(r => r.data).catch(csaListErrorHandler);

export const csasByEodRange = dateObject => axios.get('Csa/CsasByEodRange', { params: dateObject })
    .then(r => r.data).catch(csaListErrorHandler);

export const simmVersion = () => axios.get('SystemInfo/SimmEngineVersion')
    .then(r => r.data).catch(eodErrorHandler);
